<template>
	<div class="hardwareContainer">
		<img v-for="(item,i) in hardwareData" :key="i" class="img_scale" :src="item.img">
		<!-- <img class="img_scale" src="../../assets/static/images/hardware_1.png">
		<img src="../../assets/static/images/hardware_2.png">
		<img class="img_scale" src="../../assets/static/images/hardware_3.png">
		<img src="../../assets/static/images/hardware_4.png">
		<img class="img_scale" src="../../assets/static/images/hardware_5.png">
		<img src="../../assets/static/images/hardware_6.png">
		<img class="img_scale" src="../../assets/static/images/hardware_7.png">
		<img src="../../assets/static/images/hardware_8.png">
		<img class="img_scale" src="../../assets/static/images/hardware_9.png">
		<img src="../../assets/static/images/hardware_10.png"> -->
		<!-- <div :class="i%2==0?'hardwareBox_lage_two':'hardwareBox_lage_one'" v-for="i in 10" :key="i">
			<div class="hardwareBox_little">
				<p class="hardwareBox_little_title">仪器智能控制器<span class="hardwareBox_id">(A10)</span></p>
				<p class="hardwareBox_little_msg">通过人脸识别或刷卡鉴权方式，控制仪器设备上下机操作，自动记录使用人，使用机时等信息</p>
				<div class="hardwareBox_logo_box">
					<div class="hardwareBox_logo_box_item" v-for="i in 4" :key="i">
						<img class="hardwareBox_logo_box_img" src="../../assets/static/images/fz.png">
						<p class="hardwareBox_text">预约可视化</p>
					</div>
				</div>
			</div>
			<img class="hardwareBox_m_img" src="../../assets/static/images/fz.png">
		</div> -->
	</div>
</template>

<script>
	
	import {hardware} from '../../common/api.js'
	 export default{
		 data(){
			 return{
				 hardware,
				 hardwareData:[],
			 }
		 },
		 methods:{
			async getHardwareDetails(){
				const res =  await hardware({PageIndex:1,PageSize:10000});
				this.hardwareData= res.data.Data
			 },
			
		 },
		  created(){
			this.getHardwareDetails()
		 }
	 } 
</script>

<style lang="less" scoped>
	.hardwareContainer{
		width: 75rem;
		margin: 0 auto;
		.hardwareBox_lage_one{
			width: 75rem;
			height: 32.5625rem;
			
			margin: 0 auto;
			display: flex;
			justify-content: space-around;
			align-items: center;
		
		}
		.hardwareBox_lage_two{
			width: 75rem;
			height: 32.5625rem;
			background: #F9FAFC;
			margin: 0 auto;
			display: flex;
			justify-content: space-around;
			align-items: center;
			flex-direction: row-reverse;
			
		}
		.hardwareBox_m_img{
			width: 24.125rem;
			height: 18.875rem;
			transform: scale(0.9);
		}
		.hardwareBox_logo_box_img{
			width: 3.625rem;
			height: 3.625rem;
			padding: 0;
		}
		.hardwareBox_little{
			display: flex;
			flex-direction: column;
			justify-content: center;
			    height: 100%;
			width: 26.125rem;
		}
		.hardwareBox_logo_box{
			display: flex;
			
			
			width: 100%;
			
			margin-top: 4rem;
			
		}
		.hardwareBox_logo_box_item{
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-right: 1.5rem;
			
		}
		.hardwareBox_little_title{
			// width: 19.6875rem;
			// height: 3.9375rem;
			font-size: 2.8125rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
		}
		.hardwareBox_id{
			font-size: 30px;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
			}
			.hardwareBox_little_msg{
				font-size: 1.125rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
			}
			.hardwareBox_text{
				font-size: 0.875rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #666666;
				width: 4.6875rem;
				margin-top: 0.8rem;
			}
	}
	.hardwareContainer img{
		width: 75rem;
		padding: 1rem;
	}
	.img_scale{
		transform: scale(0.9);
	}
	
</style>
